import { createI18n } from 'vue-i18n'
import messages from '@internal/i18n/messages/index'

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages,
})
